import React, { useState } from 'react';
import { MessageCircle, Mail, Clock, X } from 'lucide-react';
export function Footer() {
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  return <footer id="contacto" className="bg-[#050608] pt-20 pb-10 px-6 border-t border-white/5" data-id="element-67">
      <div className="max-w-7xl mx-auto" data-id="element-68">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-69">
          <div className="lg:col-span-2" data-id="element-70">
            <img src="https://cdn.magicpatterns.com/uploads/hdwTRmatKyUZFdT516kJwa/Logo_sin_fondo.png" alt="Krove Latam Logo" className="h-24 md:h-28 object-contain mb-6" data-id="element-71" />
            <p className="text-text-secondary max-w-sm mb-8 leading-relaxed" data-id="element-72">
              Creamos Landing Pages profesionales, diseñadas específicamente
              para negocios locales, listas para conseguirte clientes desde el
              primer día.
            </p>
            <p className="text-xl font-serif font-medium text-white italic" data-id="element-73">
              "Porque tu negocio merece ser visto."
            </p>
          </div>

          <div data-id="element-74">
            <h4 className="text-white font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-75">
              Contacto Directo
            </h4>
            <ul className="space-y-4" data-id="element-76">
              <li data-id="element-77">
                <a href="https://wa.me/573135250384" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-text-secondary hover:text-white transition-colors group" data-id="element-78">
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-[#25D366]/20 group-hover:text-[#25D366] transition-colors" data-id="element-79">
                    <MessageCircle className="w-5 h-5" data-id="element-80" />
                  </div>
                  <span data-id="element-81">+57 313 525 0384</span>
                </a>
              </li>
              <li data-id="element-82">
                <a href="mailto:krove.lat@gmail.com" className="flex items-center gap-3 text-text-secondary hover:text-white transition-colors group" data-id="element-83">
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-primary/20 group-hover:text-primary transition-colors" data-id="element-84">
                    <Mail className="w-5 h-5" data-id="element-85" />
                  </div>
                  <span data-id="element-86">krove.lat@gmail.com</span>
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-87">
            <h4 className="text-white font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-88">
              Horarios de Atención
            </h4>
            <div className="flex items-start gap-3 text-text-secondary" data-id="element-89">
              <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0" data-id="element-90">
                <Clock className="w-5 h-5" data-id="element-91" />
              </div>
              <div className="pt-2" data-id="element-92">
                <p className="mb-1" data-id="element-93">Lunes - Sábado</p>
                <p className="text-white font-medium" data-id="element-94">9:00 AM - 6:00 PM</p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-95">
          <p className="text-text-secondary text-sm" data-id="element-96">
            © 2026 Krove Latam. Todos los derechos reservados.
          </p>
          <div className="flex gap-6 text-sm text-text-secondary" data-id="element-97">
            <button onClick={() => setTermsOpen(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-98">
              Términos y Condiciones
            </button>
            <button onClick={() => setPrivacyOpen(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-99">
              Política de Privacidad
            </button>
          </div>
        </div>
      </div>

      {/* Terms & Conditions Modal */}
      {termsOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setTermsOpen(false)} data-id="element-100">
          <div className="relative bg-[#0F111A] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-101">
            <button onClick={() => setTermsOpen(false)} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors" data-id="element-102">
              <X className="w-4 h-4 text-white" data-id="element-103" />
            </button>

            <h2 className="text-2xl font-serif font-bold text-white mb-6" data-id="element-104">
              Términos y Condiciones de Uso - Krove Latam
            </h2>

            <div className="space-y-5 text-gray-300 text-sm leading-relaxed" data-id="element-105">
              <div data-id="element-106">
                <h3 className="text-white font-semibold mb-2" data-id="element-107">
                  1. Aceptación de Términos
                </h3>
                <p data-id="element-108">
                  Al contratar los servicios de Krove Latam, el cliente acepta
                  los presentes términos.
                </p>
              </div>

              <div data-id="element-109">
                <h3 className="text-white font-semibold mb-2" data-id="element-110">
                  2. Servicios y Tarifas
                </h3>
                <ul className="list-disc list-inside space-y-1" data-id="element-111">
                  <li data-id="element-112">
                    El costo base de la Landing Page es de $197 USD (pago único
                    por diseño y estructura).
                  </li>
                  <li data-id="element-113">
                    El servicio de mantenimiento, hosting y soporte técnico
                    tiene un valor de $20 USD mensuales.
                  </li>
                </ul>
              </div>

              <div data-id="element-114">
                <h3 className="text-white font-semibold mb-2" data-id="element-115">
                  3. Proceso de Trabajo
                </h3>
                <p data-id="element-116">
                  El cliente se compromete a entregar la información necesaria
                  (logos, textos básicos, imágenes) para iniciar el proyecto.
                  Krove Latam utiliza herramientas de Inteligencia Artificial
                  para optimizar la estructura y diseño base.
                </p>
              </div>

              <div data-id="element-117">
                <h3 className="text-white font-semibold mb-2" data-id="element-118">
                  4. Propiedad Intelectual
                </h3>
                <p data-id="element-119">
                  Una vez liquidado el pago total, el diseño final pertenece al
                  cliente. Sin embargo, Krove Latam se reserva el derecho de
                  mostrar el proyecto en su portafolio comercial.
                </p>
              </div>

              <div data-id="element-120">
                <h3 className="text-white font-semibold mb-2" data-id="element-121">
                  5. Limitación de Responsabilidad
                </h3>
                <p data-id="element-122">
                  Krove Latam no se hace responsable por caídas del servidor de
                  terceros o mal uso de la página por parte del cliente una vez
                  entregada.
                </p>
              </div>

              <div data-id="element-123">
                <h3 className="text-white font-semibold mb-2" data-id="element-124">
                  6. Cancelaciones
                </h3>
                <p data-id="element-125">
                  El pago inicial de $197 no es reembolsable una vez iniciado el
                  proceso de diseño base con IA.
                </p>
              </div>
            </div>
          </div>
        </div>}

      {/* Privacy Policy Modal */}
      {privacyOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setPrivacyOpen(false)} data-id="element-126">
          <div className="relative bg-[#0F111A] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-127">
            <button onClick={() => setPrivacyOpen(false)} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors" data-id="element-128">
              <X className="w-4 h-4 text-white" data-id="element-129" />
            </button>

            <h2 className="text-2xl font-serif font-bold text-white mb-6" data-id="element-130">
              Políticas de Privacidad - Krove Latam
            </h2>

            <div className="space-y-5 text-gray-300 text-sm leading-relaxed" data-id="element-131">
              <div data-id="element-132">
                <h3 className="text-white font-semibold mb-2" data-id="element-133">
                  1. Recolección de Datos
                </h3>
                <p data-id="element-134">
                  En krove.lat, recolectamos información personal (nombre,
                  email, teléfono) únicamente cuando el usuario la proporciona
                  voluntariamente a través de nuestros formularios de contacto o
                  WhatsApp.
                </p>
              </div>

              <div data-id="element-135">
                <h3 className="text-white font-semibold mb-2" data-id="element-136">
                  2. Uso de la Información
                </h3>
                <p className="mb-2" data-id="element-137">
                  Los datos se utilizan exclusivamente para:
                </p>
                <ul className="list-disc list-inside space-y-1" data-id="element-138">
                  <li data-id="element-139">
                    Proveer los servicios de arquitectura web y SEO contratados.
                  </li>
                  <li data-id="element-140">Enviar actualizaciones sobre el proyecto.</li>
                  <li data-id="element-141">Comunicar ofertas exclusivas de la marca (opcional).</li>
                </ul>
              </div>

              <div data-id="element-142">
                <h3 className="text-white font-semibold mb-2" data-id="element-143">
                  3. Protección de Datos
                </h3>
                <p data-id="element-144">
                  No vendemos, alquilamos ni compartimos tus datos con terceros.
                  Utilizamos herramientas de seguridad digital para proteger tu
                  información.
                </p>
              </div>

              <div data-id="element-145">
                <h3 className="text-white font-semibold mb-2" data-id="element-146">4. Cookies</h3>
                <p data-id="element-147">
                  Nuestro sitio utiliza cookies para mejorar la experiencia del
                  usuario y analizar el tráfico web mediante herramientas de
                  análisis.
                </p>
              </div>

              <div data-id="element-148">
                <h3 className="text-white font-semibold mb-2" data-id="element-149">
                  5. Derechos del Usuario
                </h3>
                <p data-id="element-150">
                  Puedes solicitar el acceso, rectificación o eliminación de tus
                  datos en cualquier momento escribiendo a{' '}
                  <a href="mailto:krove.lat@gmail.com" className="text-primary hover:underline" data-id="element-151">
                    krove.lat@gmail.com
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>}
    </footer>;
}